import {
  createElement,
  PropsWithChildren,
  ReactElement,
  ReactNode,
} from 'react';
import * as prod from 'react/jsx-runtime';
import { unified } from 'unified';
import rehypeReact, { Options as RehypeOptions } from 'rehype-react';
import remarkParse from 'remark-parse';
import remarkBreaks from 'remark-breaks';
import remarkRehype from 'remark-rehype';
import rehypeSanitize from 'rehype-sanitize';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { RehypeFilterOptions, rehypeFilter } from './rehypeFilter';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from '../../components/common/MarkdownTableComponents';

export type ParseMarkdownOptions = Pick<RehypeOptions, 'components'> &
  RehypeFilterOptions;

// @ts-expect-error: the react types are missing.
const production = { Fragment: prod.Fragment, jsx: prod.jsx, jsxs: prod.jsxs };

// Custom link component to force target="_blank" and rel="noopener noreferrer"
const Link = (props: any) =>
  createElement(
    'a',
    {
      ...props,
      target: '_blank',
      rel: 'noopener noreferrer',
    },
    props.children,
  );

export function parseMarkdown(
  content: string,
  options?: ParseMarkdownOptions,
): ReactNode {
  const components = {
    a: Link,
    table: Table,
    thead: Thead,
    tbody: Tbody,
    tr: Tr,
    th: Th,
    td: Td,
    ...(options?.components || {}),
  };

  const { result } = unified()
    .use(remarkParse)
    .use(remarkGfm) // Support for GitHub Flavored Markdown
    .use(remarkBreaks)
    .use(remarkRehype, { allowDangerousHtml: true })
    .use(rehypeRaw)
    .use(rehypeSanitize)
    // @ts-expect-error: the react types are missing.
    .use(rehypeReact, { ...production, components })
    .use(rehypeFilter, {
      allowElement: options?.allowElement,
      allowedElements: options?.allowedElements,
      disallowedElements: options?.disallowedElements,
      unwrapDisallowed: options?.unwrapDisallowed,
    })
    .processSync(content);

  // unwraps the outer <div> element
  return (result as ReactElement<PropsWithChildren<{}>>).props.children;
}
